module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921030834_T.ef11ec14.jpg";